import React from 'react';
import { useCurrency, currencies } from '../context/CurrencyContext';
import { Globe } from 'lucide-react';

const CurrencySelector = ({ className = '', compact = false }) => {
  const { currency, setCurrency } = useCurrency();

  if (compact) {
    return (
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className={`bg-[#0A0F1C] border border-[#2563EB]/30 rounded-lg px-3 py-2 text-[#F8FAFC] text-sm focus:outline-none focus:border-[#2563EB] cursor-pointer ${className}`}
      >
        {Object.entries(currencies).map(([code, { symbol, name }]) => (
          <option key={code} value={code}>
            {symbol} {code}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <Globe className="w-4 h-4 text-[#94A3B8]" />
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="bg-[#0A0F1C] border border-[#2563EB]/30 rounded-lg px-4 py-2 text-[#F8FAFC] focus:outline-none focus:border-[#2563EB] cursor-pointer"
      >
        {Object.entries(currencies).map(([code, { symbol, name }]) => (
          <option key={code} value={code}>
            {symbol} {code} - {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySelector;
